import { useState, type FormEvent } from "react";
import { ArrowRight, Zap } from "lucide-react";
import { ApiError } from "@am/shared";
import { useAuth } from "../auth/AuthProvider";

export function LoginPage() {
  const { login } = useAuth();
  const [key, setKey] = useState("");
  const [remember, setRemember] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    if (submitting) return;
    setSubmitting(true);
    setError(null);
    try {
      await login(key, remember);
    } catch (err) {
      const msg = err instanceof ApiError && err.status === 401
        ? "Clé incorrecte ou plateforme non configurée."
        : err instanceof Error
          ? err.message
          : "Erreur inconnue.";
      setError(msg);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="login" id="login-view">
      <div className="login-card">
        <div className="login-brand">
          <div className="login-mark"><Zap size={18} /></div>
          <div>
            <div className="login-brand-name">Platform Admin</div>
            <div className="login-brand-sub">Super Administrator Console</div>
          </div>
        </div>

        <h1>
          Gérer les <em>tenants</em>
          <br />
          de la plateforme.
        </h1>
        <p>Accès super-administrateur. Saisissez la clé d'administration plateforme.</p>

        {error && (
          <div className="login-error" style={{ display: "block" }}>
            {error}
          </div>
        )}

        <form onSubmit={onSubmit}>
          <div className="field">
            <label htmlFor="platform-key">Clé administrateur plateforme</label>
            <input
              type="password"
              id="platform-key"
              autoComplete="off"
              placeholder="••••••••••••••••"
              value={key}
              onChange={(e) => setKey(e.target.value)}
              required
            />
          </div>
          <label className="check-row" style={{ marginBottom: 20 }}>
            <input type="checkbox" checked={remember} onChange={(e) => setRemember(e.target.checked)} />
            Se souvenir de moi
          </label>
          <button type="submit" className="btn-primary" disabled={submitting}>
            {submitting ? "…" : <span style={{ display: "flex", alignItems: "center", gap: 6, justifyContent: "center" }}>Accéder <ArrowRight size={15} /></span>}
          </button>
        </form>
      </div>
    </div>
  );
}
